import { render, staticRenderFns } from "./JobLaboralFunctionList.vue?vue&type=template&id=bc1def70"
import script from "./JobLaboralFunctionList.vue?vue&type=script&lang=js"
export * from "./JobLaboralFunctionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports